const PageRoutes = Object.freeze({
  appHome: '/',
  contract: '/contract',
  consent: '/contract/consent',
  otp: '/contract/otp',
  thankPage: '/contract/thankPage',
  errorPage: '/contract/errorPage',
  expiredLink: '/contract/expiredLink',
  skippedPage: '/contract/skippedPage',
  resetPage: '/contract/resetPage',
  signDocument: '/contract/signDocument',
  downloadDocument: '/contract/downloadDocument'
});

export default PageRoutes;
